import { defineStore } from 'pinia'
import { UserState } from './user.interface'

const userInfo = JSON.parse(localStorage.getItem('userInfo') as string) || {}
const useUserStore = defineStore('user', {
  state: (): UserState => ({
    id: userInfo.id,
    username: userInfo.username,
    name: userInfo.name,
    sex: userInfo.sex,
    mail: userInfo.mail,
    phone: userInfo.phone,
    admin: userInfo.admin,
    roles: [],
    createTime: userInfo.createtime,
    updateTime: userInfo.updatetime
  }),

  getters: {

  },

  actions: {

  }
})

export default useUserStore
